<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useBookingSlotsApi } from '../api/slots-management/booking.hook'
import BookingSlotsSection from './slots-management/BookingSlotsSection.vue'

defineOptions({
  name: 'DemosSlotsManagementPage',
})

onMounted(() => {
  void useBookingSlotsApi()
})

useOnTimezoneChange(() => {
  void useBookingSlotsApi()
})
</script>

<template>
  <BookingSlotsSection />
</template>
